import React, { useState } from "react";

import OrderRow from "./OrderRow";
import ShipmentBuilder from "../ShipmentBuilder";
import { IconChevronCircle } from "../../../../../components/Layout/Icons";

const ShipmentBuilderParent = ({
  pickup_address_id,
  supplying_ids,
  order_rows,
  initialServices,
  order_id,
  id_order,
  order_rows_accepted,
  order_rows_accepted_func,
  handleSelected,
  handleCheck,
  additionalOptions,
  order_inf,
  order_cart_rules,
  pickedSupplierId,
}) => {
  const [open, setOpen] = useState(false);
  return (
    <div
      className="shiping_index_smaller mb-2 position-relative"
      style={{
        background: "#FEFEFE",
        border: "1px solid #E8E8E8",
        boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.05)",
        borderRadius: 3,
        width: 400,
      }}
    >
      <div
        className="p-2"
        style={{
          borderBottom: open ? "1px solid #E8E8E8" : "none",
        }}
      >
        {order_rows.map((or_item) => {
          return (
            <OrderRow
              type="shipping"
              key={`or_item_${or_item.id}`}
              {...or_item}
              order_id={order_id}
              invoicesTotal={[]}
              order_rows_accepted={order_rows_accepted}
              order_rows_accepted_func={order_rows_accepted_func}
              handleSelected={handleSelected}
              handleCheck={handleCheck}
              pickedSupplierId={pickedSupplierId}
            />
          );
        })}
        <div
          className={`position-absolute ${open ? "" : "mass_bulk_action_open"}`}
          style={{
            right: 5,
            top: 5,
          }}
          onClick={() => setOpen((prev) => !prev)}
        >
          <IconChevronCircle up={open} />
        </div>
      </div>
      <div className={open ? "d-block" : "d-none"}>
        <ShipmentBuilder
          initial_pickup_address_id={pickup_address_id}
          supplying_ids={supplying_ids}
          order_rows={order_rows}
          initialServices={initialServices}
          order_id={order_id}
          id_order={id_order}
          additionalOptions={additionalOptions}
          order_inf={order_inf}
          order_cart_rules={order_cart_rules}
        />
      </div>
    </div>
  );
};

export default ShipmentBuilderParent;
